// eslint-disable-next-line no-unused-vars
export var NavigationTypeEnum;
(function (NavigationTypeEnum) {
    NavigationTypeEnum["PUSH"] = "PUSH";
    NavigationTypeEnum["REPLACE"] = "REPLACE";
})(NavigationTypeEnum || (NavigationTypeEnum = {}));
